<template>
  <header class="top-menu">
    <div class="top-menu__brand">OpenAS2</div>

    <div class="top-menu__actions">
      <el-button circle plain icon="el-icon-s-operation" @click="openSidemenu" />

      <el-dropdown trigger="click">
        <span class="top-menu__user">
          <el-avatar size="small">{{ abbreviationName }}</el-avatar>
          <span>{{ userName }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="logout">Sign Out</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </header>
</template>

<script>
import store from '../store'

export default {
  name: 'top-menu',
  props: {
    openSidemenu: {
      require: false,
    },
  },
  computed: {
    userName() {
      return store.state.username || ''
    },
    abbreviationName() {
      return (store.state.username || 'NA').substr(0, 2).toUpperCase()
    },
  },
  methods: {
    logout: function (e) {
      if (e && e.preventDefault) e.preventDefault()
      store.dispatch('logoutAction', {})
    },
  },
}
</script>

<style scoped>
.top-menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background: #ffffff;
  color: #303133;
  border-bottom: 1px solid #ebeef5;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
}

.top-menu__brand {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.top-menu__actions {
  display: flex;
  align-items: center;
  gap: 14px;
}

.top-menu__user {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #303133;
  cursor: pointer;
}
</style>
